export default "https://cdn-web.disco.co/video-b2a07a7b04708c283041ba69e0ac3719.png";